// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3pqGc","consentsList":"PatientConsents_consentsList__3x3Bq","consentsListEmpty":"PatientConsents_consentsListEmpty__22m4g"};